import { RadioGroup, Radio, HStack, Text } from "@chakra-ui/react";
import { useState } from "react"

export default function ShowOrientation({
    orientationOptions,
    defaultOption,
    onClickHandler,
}) {
    const [value, setValue] = useState(defaultOption)
    const selectedOption = orientationOptions?.find(element => element.value === value);
    if (selectedOption?.disabled) {
        // reset value
        setValue("");
        onClickHandler("");
    }

    function onRadioValueChanged(newValue) {
        setValue(newValue);
        onClickHandler(newValue);
    }

    return (
        <RadioGroup value={value} onChange={onRadioValueChanged}>
            <HStack spacing="20px">
                {orientationOptions?.map((option) => (
                    <Radio
                        size="lg"
                        key={option.id}
                        value={option.value}
                        disabled={option.disabled}
                    >
                        <Text fontSize="16px" fontWeight="400" m="0px" fontFamily="Roboto">
                            {option.label}
                        </Text>
                    </Radio>
                ))}
            </HStack>
        </RadioGroup>
    );
}